<script setup>
import {getCurrentInstance, onMounted, onUnmounted, reactive, ref} from 'vue'
import {Progress, State, can, delay, go} from '@/paks/vu-app'
import DeviceClaim from './DeviceClaim.vue'
import {Device, Generic} from '@/paks/mgr-models'

const {proxy: self} = getCurrentInstance()

const Fields = [
    {name: 'choose', title: 'Select', icon: '$click', width: '5%'},
    {name: 'edit', icon: '$edit', width: '5%', desktop: true},
    {name: 'id', title: 'Device ID'},
    {name: 'created', title: 'Made', desktop: true, format: v => v.toLocaleString()},
    {name: 'name', desktop: true},
    {name: 'model'},
    {name: 'connection', desktop: true, icon: {
        online:   {name: '$success', color: 'green'},
        offline:  {name: '$close', color: 'red'},
    }},
    {name: 'state', desktop: true},
    {name: 'test', desktop: true},
    {name: 'version', desktop: true},
]

const page = reactive({
    active: null,
    device: {},
    devices: null,
    select: {},
    showClaim: false,
    showEdit: false,
})

//  Component references
const table = ref(null)
const confirm = ref(null)

onMounted(async () => {
    page.title = self.$route.meta.view.title
    if (can('admin')) {
        page.select = {actions: {Claim: 0, Release: 2}, multi: true, property: 'select'}
    } else {
        page.select = {}
    }
    daemon()
})

onUnmounted(() => {
    page.active = false
})

async function load(args) {
    page.devices = await Generic.find('Device', args)
    return page.devices
}

async function daemon() {
    page.active = true
    while (page.active) {
        if (State.auth.ready) {
            await load()
        }
        await delay(30 * 1000)
    }
}

async function releaseDevices(items) {
    if (!(await confirm.value.ask(`Do you want to release the selected devices?`))) {
        return
    }
    Progress.start()
    for (let item of items) {
        await Device.release({id: item.id})
    }
    await load()
    Progress.stop('Device Released')
}

async function clicked({action, item, items, column}) {
    if (!can('admin')) return
    if (action == 'add') {
        claimDevice({})
    } else if (action == 'edit') {
        for (let item of items) {
            editDevice(item)
            break
        }
    } else if (action == 'delete') {
        for (let item of items) {
            await deleteDevice(item)
        }
    } else if (action == 'cell') {
        if (column.name == 'edit') {
            editDevice(item)
        } else {
            State.context.setKey('deviceId', item.id)
            // State.context.setKey('title', item.name)
            State.context.setKey('device', item.name)
            go('/')
        }
    } else if (action == 'claim') {
        await claimDevice({})
    } else if (action == 'release') {
        await releaseDevices(items)
    }
}

async function claimDevice(device) {
    page.showClaim = device ? true : false
    page.device = device || {}
    if (!device) {
        await load()
    }
}

async function editDevice(device) {
    page.device = device || {}
    if (device) {
        page.device = device // await Generic.get('Device', {id: device.id})
    } else {
        await load()
    }
    page.showEdit = device ? true : false
}
</script>

<template>
    <div class="page device-list">
        <vu-table
            name="devices"
            options="dynamic,filter,toolbar"
            sort="name:asc"
            ref="table"
            width="100%"
            :data="page.devices"
            :fields="Fields"
            :pageSize="25"
            :select="page.select"
            @click="clicked"
            @reload="load">
            <template v-slot:more="props">
                <v-btn
                    class="mr-2"
                    color="primary"
                    @click="claimDevice({})">
                    Claim {{ page.title || 'Device' }}
                </v-btn>
            </template>
        </vu-table>

        <vu-panel v-model="page.showClaim" @close="claimDevice" :widths="['600px']">
            <DeviceClaim :id="page.device.id" @input="claimDevice" ref="edit" />
        </vu-panel>

        <vu-panel v-model="page.showEdit" @close="editDevice()" :widths="['600px']">
            <GenericEdit :item="page.device" model="Device" title="Modify Device" @input="editDevice()" ref="edit" />
        </vu-panel>

        <vu-confirm ref="confirm" />
    </div>
</template>

<style lang="scss">
.device-list {
    @media (max-width: 640px) {
        height: calc(100vh - 255px);
    }
    .product-select {
        display: flex;
        padding: 16px 20px 16px 20px;
        margin-bottom: 20px;
        border: 1px solid rgb(var(--v-theme-border)) !important;
    }
    .v-input--switch {
        .v-input__slot {
            width: auto;
        }
    }
    .action {
        margin-right: 10px !important;
        border: 1px solid rgb(var(--v-theme-border));
        background: none !important;
        box-shadow: none !important;
    }
}
</style>
